import React, { useContext } from "react";
import { ClinicaContext } from "../../../context/clinica-context";
import PdfImpresso from "./PdfImpresso";

const MODELOS = {
  modelo1: PdfImpresso,
};

function PdfImpressoWrapper({ showPreviousPage, impressoData }) {
  const { configuracoes } = useContext(ClinicaContext);
  const modeloKey = configuracoes?.configuracoes?.modelosDocumentos?.impresso || "modelo1";
  const Modelo = MODELOS[modeloKey] ?? PdfImpresso;

  return (
    <div>
      <Modelo impressoData={impressoData} showPreviousPage={showPreviousPage} />
    </div>
  );
}

export default PdfImpressoWrapper;
